import {
    reactive,
} from 'vue'

const click = (e, ctx, store) => {
    ctx.emit(e.type, e)
}

const ABtnRenderless = (props, ctx) => {

    let store = reactive({
        state: {
            ...props.state
        }
    })

    return {
        store,
    }
}

export {
    ABtnRenderless,
    click,
}